<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.unitName"
              placeholder="请输入收款单位"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.projectName"
              placeholder="请输入项目名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="addFun()"
            >
              创建付款单
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @add="addFun"
        />
      </div>

      <!-- 新增 -->
      <add-edit-dialog
        :event-type="'add'"
        :data-array="selectArray"
        :dialog-title="dialogAddEditTitle"
        :dialog-visible.sync="dialogAddEditVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 新增 修改
import addEditDialog from './addEditDialog'
import { getUserId } from '@/utils/auth'
import { loadPayableListDataApi } from '@/api/payable'

export default {
  name: 'PayableTodoPaid',
  components: { CustomTable, addEditDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'payable_todo_paid_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'add',
            label: '创建付款单',
            method: 'add'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            unitName: '',
            projectName: '',
            todoPay: 'true'
          }
        }
      },
      payMethodOptions: [{ value: 1, label: '对公转账' }, { value: 3, label: '个人垫付' }],
      typeOptions: [{ value: 1, label: '应付款' }, { value: 2, label: '保证金' }, { value: 3, label: '押金' }],
      multipleSelection: [],
      isPaging: true,
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      selectArray: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'provinceName', label: '省区', filterColumn: 'bill.province_name', width: 90 },
          { prop: 'cityName', label: '城市', filterColumn: 'bill.city_name', width: 100 },
          { prop: 'unitName', label: '收款单位', filterColumn: 'u.unit_name', width: 180 },
          { prop: 'typeValue', label: '应付类型', filterColumn: 'bill.type', filterValue: 'type', filterArray: this.typeOptions, width: 120 },
          { prop: 'paymentSubjectValue', label: '付款科目', filterColumn: 'bill.payment_subject', filterValue: 'paymentSubject', filterArray: this.subjectOptions, width: 120 },
          { prop: 'projectDateValue', label: '项目时间', filterColumn: 'bill.project_date', width: 110, isBetween: true },
          { prop: 'projectName', label: '项目名称', filterColumn: 'bill.project_name', width: 180 },
          { prop: 'businessProvinces', label: '业务区域', filterColumn: 'bill.business_provinces', width: 160 },
          { prop: 'payableAmount', label: '应付金额', filterColumn: 'bill.payable_amount', width: 120, formatPrice: true },
          { prop: 'paidAmount', label: '已付金额', filterColumn: 'bill.paid_amount', width: 120, formatPrice: true },
          { prop: 'leftAmount', label: '未付金额', filterColumn: 'bill.left_amount', width: 120, formatPrice: true },
          { prop: 'paymentHandlerName', label: '付款经办人', filterColumn: 'bill.payment_handler_name', width: 120 },
          { prop: 'remark', label: '备注', filterColumn: 'bill.remark', width: 150 }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.sort.order = ''
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      loadPayableListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 创建报告
    addFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({ message: '请选择要付款的应付款单', type: 'warning' })
        return false
      } else {
        let unitId = ''
        let sameUnit = false
        let handlerId = ''
        let sameHandler = false
        let payMethod = ''
        let sameMethod = false
        this.multipleSelection.forEach(item => {
          if (unitId === '') {
            unitId = item.unitId
          } else if (unitId !== item.unitId) {
            sameUnit = true
          }
          if (handlerId === '') {
            handlerId = item.paymentHandler
          } else if (handlerId !== item.paymentHandler) {
            sameHandler = true
          }
          if (payMethod === '') {
            payMethod = item.payMethod
          } else if (payMethod !== item.payMethod) {
            sameMethod = true
          }
        })
        if (sameUnit) {
          this.$message({ message: '请选择相同收款单位的应付款单', type: 'warning' })
          return false
        }
        if (sameHandler) {
          this.$message({ message: '请选择相同付款经办人的应付款单', type: 'warning' })
          return false
        }
        if (sameMethod) {
          this.$message({ message: '请选择相同付款方式的应付款单', type: 'warning' })
          return false
        }
        if (Number(getUserId()) !== 1 && Number(getUserId()) !== 55 && Number(getUserId()) !== 147 && Number(getUserId()) !== 347 && Number(getUserId()) !== 352 && Number(getUserId()) !== Number(handlerId)) {
          this.$message({ message: '您不是指定的付款经办人，不能新增付款单', type: 'warning' })
          return false
        }
        this.selectArray = this.multipleSelection
        this.dialogAddEditTitle = '新增付款单'
        this.dialogAddEditVisible = !this.dialogAddEditVisible
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
